




import React from 'react';
import { useContext, useState } from 'react';
import { Buttons } from '../../../../components/ui/button';
import { Badge } from '../../../../components/ui/badge';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../imports/svg-knollny4nu';
import svgThankYou from '../../../../imports/svg-fi1d3y679l';
import { ProfileContext } from '../EntirePreview';
import { ScoreContext } from '../GamePreview';
import { useNavigate, useParams } from 'react-router-dom';
import { Textarea } from "../../../../components/ui/textarea";
import { updateLearnerDetails } from 'utils/gameApplication/gamePlayService';
import { getAssignedGames} from '../../../../../src/utils/activitycontrols/activities';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import { thankYouPopup} from '../../../../../src/utils/gameApplication/gameActivityService';

import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomRankingIcon,
  CustomSettingsIcon,
} from '../../../../components/ui/CustomIcons';
// import imgBackground from '../../../../../public/background.png';
// import topNav from '../../../../../public/top-nav-bg.png';
import { useColor } from '../../../../components/ui/ColorContext';
import ColorPicker from '../../../../components/ui/ColorPicker';
import { Slider } from '../../../../components/ui/slider';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '../../../../components/ui/dialog';
import { insertGameFedback } from '../../../../../src/utils/game/gameService';
import { updateScreenActivity } from '../common';

// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};


   const FeedbackCard: React.FC<{
      icon: React.ReactNode;
      text: string;
      isSelected: boolean;
      onClick: () => void;
    }> = ({ icon, text, isSelected, onClick }) => {
        const { primaryColor } = useColor();
        return (
      <div
        className="backdrop-blur-[2.499rem] backdrop-filter  grow h-[4.198rem] min-h-px min-w-px relative rounded-[0.6rem] shrink-0 cursor-pointer hover:scale-105 transition-all duration-300 flex-1 w-full"
        onClick={onClick}
        style={{
          background: isSelected
            ? `linear-gradient(135deg, rgba(${hexToRgb(
              primaryColor
            )}, 0.3) 0%, rgba(${hexToRgb(primaryColor)}, 0.1) 100%)`
            : `linear-gradient(21deg, rgba(10, 10, 10, 0.70) -10.76%, rgba(${hexToRgb(
              primaryColor
            )}, 0.2) 127.18%)`,
        }}
      >
        <div className="flex flex-row items-center overflow-clip relative h-full w-full">
          <div className="box-border content-stretch flex flex-row gap-2.5 h-[4.198rem] items-center justify-start p-[1.2rem] relative w-full">
            {icon}
            <div className="flex flex-col font-rubik font-semibold justify-center leading-[0] relative text-[#ffffff] text-sm text-left tracking-[-0.04px]">
              <p className="adjustLetterSpacing block leading-[1rem]">{text}</p>
            </div>
          </div>
        </div>
        <div className="absolute inset-0 pointer-events-none shadow-[1.599px_3.199px_12.795px_0px_inset_rgba(248,248,248,0.06)]" />
        <div
          className="absolute border-[1.2px] border-solid inset-0 pointer-events-none rounded-[0.6rem] transition-all duration-300"
          style={{
            borderColor: isSelected ? primaryColor : "rgba(255,255,255,0.4)",
            boxShadow: isSelected
              ? `0 0 20px rgba(${hexToRgb(primaryColor)}, 0.5)`
              : "none",
          }}
        />
      </div>
    );
  }
const ThankyouFutureTheme: React.FC<{
    playMenuSound: () => void;
  formData: any;
  imageSrc: any;
  setCurrentScreenId: any;
  preloadedAssets: any;
  gameInfo: any;
  FeedbackcurrentPosition: any;
  setFeedbackCurrentPosition: (value: any) => void;
  interactionBlockArray: any;
  profileData: any;
  getFeedbackData: () => void;
  setFeedbackNavigateNext: any;
  setInterActionBlockArray: any;
  feedbackList: any;
  setCurrentQuestNo: any;
  setFirstLoading: any;
  learnerPlayList: any;
  setLearnerPlayingDetails: any;
  AssignId: any;
}> = ({
    playMenuSound,
  formData,
  imageSrc,
  setCurrentScreenId,
  preloadedAssets,
  gameInfo,
  FeedbackcurrentPosition,
  setFeedbackCurrentPosition,
  interactionBlockArray,
  profileData,
  getFeedbackData,
  setFeedbackNavigateNext,
  setInterActionBlockArray,
  feedbackList,
  setCurrentQuestNo,
  setFirstLoading,
  learnerPlayList,
  setLearnerPlayingDetails,
  AssignId,
}) => {
   // Sync old backend keys → new UI glowing keys
const keyMap: any = {
  gameContent: "content",
  gameRelevance: "relevance",
  gameBehaviour: "behaviour",
  gameGamification: "gamification",
  gameRecommendation: "recommendation",
  gameOthers: "others",
};
const valueMap: any = {
  // Content
  "I learned something useful": "useful",
  "It wasn't useful": "not-useful",

  // Relevance
  "I'll apply what I learned": "apply",
  "It's not relevant to me": "not-relevant",

  // Behaviour
  "I understood what I can do differently": "understood",
  "I'm not sure": "not-sure",

  // Gamification
  "I liked learning through this graphical theme": "like-games",
  "I didn’t like this theme": "dislike-format",

  // Recommendation
  "I would recommend this game to others": "recommend",
  "I wouldn't recommend": "not-recommend",
};
 const playClickSound = () => {
            try {
              const audio = new Audio(BtnClickSound as string);
              audio.volume = 1;
              audio.play().catch(() => { });
      
              setTimeout(() => {
                audio.pause();
                audio.currentTime = 0;
              }, 1000);
            } catch (e) {
              // ignore audio errors
            }
          };
    const useData = useContext(ProfileContext);
     const { profile, deviceInfo,
      setlearnerActivityrec} = useContext(ScoreContext);
    const user: any = JSON.parse(localStorage.getItem('user') || '{}');
    const { id } = useParams();
    const Gameid = id ? id : null;
    const GameId = learnerPlayList?.GameId;
    const playerId = learnerPlayList?.playerId;
 
    const [showCognizantPopup, setShowCognizantPopup] = useState(false);
    const [nextUnlockId, setNextUnlockId] = useState<number | null>(null);
const [showTestimonialPopup, setShowTestimonialPopup] = useState(false);
const [testimonialText, setTestimonialText] = useState("");
    const navigate = useNavigate();


  // State for tracking selected feedback options
    const [selectedFeedback, setSelectedFeedback] = useState<{
      content: 'useful' | 'not-useful' | null;
      relevance: 'apply' | 'not-relevant' | null;
      behaviour: 'understood' | 'not-sure' | null;
      gamification: 'like-games' | 'dislike-format' | null;
      recommendation: 'recommend' | 'not-recommend' | null; // <-- added
    }>({
      content: null,
      relevance: null,
      behaviour: null,
      gamification: null,
      recommendation: null,
    });
    // const [popupSeen, setPopupSeen] = useState(false);
    const [popupMode, setPopupMode] = useState(""); // "unlock" or "congrats"

    const typeofUser = gameInfo?.reviewer?.ReviewerId
      ? 'reviewer'
      : user?.data?.id
        ? 'creator'
        : null;

    const handleOtherFeedbackChange = (value: string, category: string) => {
      setUserInputs((prevInputs: any) => ({
        ...prevInputs,
        [category]: value, // Update the specific feedback category
      }));
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        playerInputs: {
          ...prev.playerInputs,
          ...prev.Thankyou,

          gameOthers: userInputs.gameOthers,
        },
      }));
    };

 

// const handleOptionClick = (value: any, category: any) => {
//   const uiKey = keyMap[category];
//   const oldValue = userInputs[category];
//   const thankyou = learnerPlayList?.playerInputs?.Thankyou;

//   const uiValue = valueMap[value]; // 👈 Convert full sentence → short keyword

//   // Toggle off logic
//   if (oldValue === value) {
//     if (oldValue === thankyou?.[category]) {
//       setUserInputs((prev: any) => ({
//         ...prev,
//         [category]: null,
//       }));

//       setSelectedFeedback((prev) => ({
//         ...prev,
//         [uiKey]: null,
//       }));
//       return;
//     }
//   }

//   // Normal update
//   setUserInputs((prev: any) => ({
//     ...prev,
//     [category]: value, // 👈 Store FULL sentence
//   }));

//   setSelectedFeedback((prev) => ({
//     ...prev,
//     [uiKey]: uiValue, // 👈 Set short keyword only for UI highlight
//   }));
// };

const handleOptionClick = (value: string, category: string) => {
  setUserInputs((prev: any) => ({
    ...prev,
    [category]: prev[category] === value ? null : value,
  }));
};

    const renderContentTy = () => {
      const linkRegex = /(https?:\/\/[^\s]+)/g;
      let parts = null;
      if (profileData?.Audiogetlanguage.length !== 0) {
        const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === formData?.gameId,
        );
        if (GameLanguageFilter.length > 0) {
          const ThankYouFiltered = GameLanguageFilter.filter(
            (key: any) => key?.fieldName === 'gameThankYouMessage',
          );
          if (ThankYouFiltered.length > 0) {
            parts = ThankYouFiltered[0]?.content
              ? ThankYouFiltered[0]?.content.split(linkRegex)
              : formData.gameThankYouMessage?.split(linkRegex);
          } else {
            parts = formData.gameThankYouMessage?.split(linkRegex);
          }
        } else {
          parts = formData.gameThankYouMessage?.split(linkRegex);
        }
      } else {
        parts = formData.gameThankYouMessage?.split(linkRegex);
      }
      // const parts = formData.gameThankYouMessage?.split(linkRegex);

      const contentWithLinks = parts?.map((part: any, index: any) => {
        if (linkRegex.test(part)) {
          return (
            <a
              key={index}
              href={part}
              style={{ color: '#caa784', textDecoration: 'underline' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        } else {
          return <React.Fragment key={index}>{part}</React.Fragment>;
        }
      });
      return <React.Fragment>{contentWithLinks}</React.Fragment>;
    };

    // for Thankyou-like data handling
    const [userInputs, setUserInputs] = useState<any>({
      gameOthers: learnerPlayList?.playerInputs?.Thankyou?.gameOthers || null,
      gameContent: learnerPlayList?.playerInputs?.Thankyou?.gameContent || null,
      gameRelevance:
        learnerPlayList?.playerInputs?.Thankyou?.gameRelevance || null,
      gameBehaviour:
        learnerPlayList?.playerInputs?.Thankyou?.gameBehaviour || null,
      gameGamification:
        learnerPlayList?.playerInputs?.Thankyou?.gameGamification || null,
      gameRecommendation:
        learnerPlayList?.playerInputs?.Thankyou?.gameRecommendation || null,
    });

    const { primaryColor } = useColor();

   

    const NavigationArrow: React.FC<{
      direction: "left" | "right";
      onClick: () => void;
    }> = ({ direction, onClick }) => {
      return (
        <Buttons
          variant="ghost"
          size="sm"
          onClick={onClick}
          className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110"
          style={{
            background: `linear-gradient(${direction === "left" ? "275.041deg" : "90deg"
              },
                rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
                primaryColor
              )}, 0.15) 84.803%)`,
            border: `1px solid ${primaryColor}`,
            boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(
              primaryColor
            )}, 0.3)`,
          }}
        >
          {direction === "left" ? (
            <ChevronLeft className="!h-4 !w-4 text-white" />
          ) : (
            <ChevronRight className="!h-4 !w-4 text-white" />
          )}
        </Buttons>
      );
    };

    const feedbackOptions = [
      formData.gameContent,
      formData.gameRecommendation,
      formData.gameRelevance,
      formData.gameGamification,
      formData.gameBehaviour,
      formData.gameOthers,
    ];
    const countfbOptions = feedbackOptions.filter(
      (option) =>
        option !== '' &&
        option !== 'false' &&
        option !== undefined &&
        option !== null,
    ).length;
    // ------------------------------------------Mohana

    const propertiesToCheck = [
      'gameContent',
      'gameRelevance',
      'gameBehaviour',
      'gameRecommendation',
      'gameGamification',
      'gameOthers',
    ];

     // Filter properties where the value is 'true'
    const trueValuesArray = propertiesToCheck.filter(
      (property) => formData[property] === 'true',
    );

    const getSelectedValue = (category: any) => {
      return userInputs[category] ?? learnerPlayList?.playerInputs?.Thankyou?.[category] ?? null;
    };


   
       const handleNext = async () => {
          playClickSound();
         setFirstLoading(true);
   
         try {
           // ============================================================
           // ## 1. SAVE FEEDBACK
           // ============================================================
           const data = {
             feedQuestNo: useData?.State?.PlayQuestNo,
             gameContent: userInputs.gameContent,
             gameRelevance: userInputs.gameRelevance,
             gameBehaviour: userInputs.gameBehaviour,
             gameGamification: userInputs.gameGamification,
             gameRecommendation: userInputs.gameRecommendation,
             gameOthers: userInputs.gameOthers,
             AssignId: AssignId
           };
   
           const result = await insertGameFedback(GameId, JSON.stringify(data));
           if (result.status !== "Success") {
             setCurrentScreenId(13);
             return false;
           }
   
           // ============================================================
           // ## 2. UPDATE LOCAL STATE
           // ============================================================
           setLearnerPlayingDetails((prev: any) => ({
             ...prev,
             playerInputs: { ...prev.playerInputs, Thankyou: userInputs },
           }));
   
           // ============================================================
           // ## 3. UPDATE LEARNER DETAILS + GET ASSIGNED GAMES
           // ============================================================
           const updateRes = await updateLearnerDetails(
             JSON.stringify({ learnerPlayList })
           );
   
           if (!updateRes?.success) {
             setCurrentScreenId(13);
             return false;
           }
   
           const assignedGamesData = await getAssignedGames(
             learnerPlayList.playerId
           );
   
           const learnerCompany = assignedGamesData?.learnerCompany;
           const nextUnlock = assignedGamesData?.nextUnlockedGameId;

           const currentGameId = Number(learnerPlayList.GameId);
   
           // ============================================================
           // ## 4. POPUP LIFETIME CHECK (LocalStorage)
           // ============================================================
           const popupKey = `popupSeen_${currentGameId}`;
           const alreadySeen = localStorage.getItem(popupKey) === "true";
   
           // ============================================================
           // ## 5. COGNIZANT POPUP RULES
           // ============================================================
           const unlockGames = [191, 188];
           const congratsGames = [184, 189];
   
           //for local
           // const unlockGames = [476, 478];
           // const congratsGames = [477, 479];
   
           // ============================================================
           // ## 6. FIRST TIME - UNLOCK POPUP
           // ============================================================
           if (
             learnerCompany === "Cognizant" &&
             unlockGames.includes(currentGameId) &&
             !alreadySeen
           ) {
             setPopupMode("unlock");
             setNextUnlockId(nextUnlock);
             setShowCognizantPopup(true);
             localStorage.setItem(popupKey, "true");
             return false;
           }
   
           // ============================================================
           // ## 7. FIRST TIME - CONGRATS POPUP (184 / 189)
           // ============================================================
           if (
             learnerCompany === "Cognizant" &&
             congratsGames.includes(currentGameId) &&
             !alreadySeen
           ) {
             setPopupMode("congrats");
             setShowCognizantPopup(true);
             localStorage.setItem(popupKey, "true");
             return false;
           }
   
           // ============================================================
           // ## 8. SECOND TIME OR FUTURE PLAYING → NO POPUP
           // ============================================================
           setCurrentScreenId(13);
           return false;
   
         } catch (err) {
           console.error("Error in handleNext:", err);
           setCurrentScreenId(13);
           return false;
         }
       };


const checkTestimonialAndProceed = async () => {
  try {
    const result = await thankYouPopup(
      JSON.stringify({ id: GameId, playerId: playerId })
    );

  

    // check db value is there
    if (result?.testimonial && result.testimonial.trim() !== "") {
      // already submitted — popup skip
      handleNext();
      return;
    }
  setlearnerActivityrec((prev:any)=>
        updateScreenActivity(
          prev,
          5,
          "Thankyou",
          deviceInfo,
          {
            feedbacks: selectedFeedback,
          }
        )
      );
    // first time — popup show
    setShowTestimonialPopup(true);

  } catch (error) {
    console.log("testimonial check error", error);
    setShowTestimonialPopup(true) // fallback
  }
};

const handleTestimonialSubmit = async () => {
  if (!testimonialText.trim()) return;

  try {
    const data = {
      testimonial: testimonialText,
      id: GameId,
            playerId: playerId,
    };

    const result = await thankYouPopup(JSON.stringify(data));
   

    setShowTestimonialPopup(false);
    setTestimonialText("");
    handleNext();
  } catch (error) {
    console.log("testimonial submit error", error);
  }
};



    const previousNavigation = () => {
        playClickSound();
      useData?.setMotionEffect(true);
      const LastquestNo = parseInt(profile.currentQuest);
      setFirstLoading(false);
      setCurrentQuestNo(LastquestNo);
      setTimeout(() => {
        if (formData?.gameIsShowTakeaway === 'true') {
          // setCurrentScreenId(7);
          setCurrentScreenId(19);
          return false;
        } else if (
          formData?.gameIsShowReflectionScreen === 'true' &&
          gameInfo?.reflectionQuestions.length > 0
        ) {
          // setCurrentScreenId(3);
          setCurrentScreenId(19);
          return false;
        } else if (
          feedbackList.length !== 0 &&
          gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
        ) {
          if (
            feedbackList?.find((item: any) => item.quest == profile.currentQuest)
          ) {
            const groupedFeedback: { [key: string]: any[] } = {};
            feedbackList.forEach((feedback: any) => {
              if (!(feedback.Seq in groupedFeedback)) {
                groupedFeedback[feedback.Seq] = [];
              }
              groupedFeedback[feedback.Seq].push(feedback);
            });
            const firstPageFeedback: any[] = [];
            Object.keys(groupedFeedback).forEach((seq: any) => {
              const lastIndex = groupedFeedback[seq].length - 1;
              if (profile.currentQuest == groupedFeedback[seq][lastIndex].quest) {
                firstPageFeedback.push(groupedFeedback[seq][lastIndex]);
              }
            });
            setFeedbackCurrentPosition(firstPageFeedback.length - 1);
            setInterActionBlockArray(firstPageFeedback.length - 1);
            getFeedbackData();
            setFeedbackNavigateNext(false);
            setCurrentScreenId(19); //Navigate to together all feedback
            // setCurrentScreenId(14); //Navigate to together all feedback
          }
        } else if (formData?.gameIsShowLeaderboard === 'true') {
          setCurrentScreenId(19);
          // setCurrentScreenId(4);
          return false;
        } else {
          setCurrentScreenId(19);
          return false;
        }
      }, 300);
    };

    // Emoji components from Figma import adapted for dynamic colors
    const FaceSmile = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="face-smile">
            <path d={svgThankYou.p7d93400} fill="#FFCE0A" opacity="0.4" />
            <path d={svgThankYou.p14e33780} fill="#FFCE0A" />
          </g>
        </svg>
      </div>
    );

    const FaceMeh = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="face-meh">
            <path d={svgThankYou.p7d93400} fill="#FFCE0A" opacity="0.4" />
            <path d={svgThankYou.p12f72cc0} fill="#FFCE0A" />
          </g>
        </svg>
      </div>
    );

    const FaceSmileWink = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="face-smile-wink">
            <path d={svgThankYou.p7d93400} fill="#FFCE0A" opacity="0.4" />
            <path d={svgThankYou.p1db62a40} fill="#FFCE0A" />
          </g>
        </svg>
      </div>
    );

    const FaceDiagonalMouth = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="face-diagonal-mouth">
            <path d={svgThankYou.p7d93400} fill="#FFCE0A" opacity="0.4" />
            <path d={svgThankYou.p29912600} fill="#FFCE0A" />
          </g>
        </svg>
      </div>
    );

    const FaceGrinStars = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="face-grin-stars">
            <path d={svgThankYou.p7d93400} fill="#FFCE0A" opacity="0.4" />
            <path d={svgThankYou.p19ed8900} fill="#FFCE0A" />
          </g>
        </svg>
      </div>
    );

    const FaceMehBlank = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="face-meh-blank">
            <path d={svgThankYou.p7d93400} fill="#FFCE0A" opacity="0.4" />
            <path d={svgThankYou.p15121800} fill="#FFCE0A" />
          </g>
        </svg>
      </div>
    );

    const Like = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="like">
            <path d={svgThankYou.p316f6700} fill="#11FCBD" />
            <path d={svgThankYou.p51d3680} fill="#11FCBD" opacity="0.4" />
          </g>
        </svg>
      </div>
    );

    const Dislike = () => (
      <div className="relative shrink-0 h-[1.2rem] w-[1.2rem]">
        <svg
          className="block h-full w-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <g id="dislike">
            <path d={svgThankYou.p3c87f300} fill="#FF0A0A" />
            <path d={svgThankYou.p6732eb0} fill="#FF0A0A" opacity="0.4" />
          </g>
        </svg>
      </div>
    );

    // Feedback Card Component with selection state
 

    return (
      <div
        className="relative w-full h-screen overflow-hidden bg-no-repeat bg-center bg-cover bg-black/90"
      // style={{ backgroundImage: `url('${imgBackground}')` }}
      >
        <div className="w-full px-4 sm:px-6 lg:px-8 pb-4 sm:pb-6 lg:pb-8 relative h-full flex">
        
         

          {/* Thank You Content */}
          <div className="h-full flex-grow flex flex-col justify-center items-center pt-24">
            <div
              className="flex flex-col gap-2 lg:gap-5 max-h-fit max-w-[74.875rem] overflow-hidden h-full w-full items-center justify-start rounded-[2.375rem] relative px-10 py-8 backdrop-filter backdrop-blur-[3.724rem]"
              style={{
                background: `linear-gradient(21deg, rgba(${hexToRgb(
                  primaryColor
                )}, 0.05) -10.76%, rgba(${hexToRgb(
                  primaryColor
                )}, 0.15) 127.18%)`,
              }}
            >
              <div className="flex flex-col gap-5 ">
                {/* Thank You Title */}
                <div className="relative">
                  <h1
                    className="text-4xl  font-normal tracking-[0.08px] text-center"
                    style={{
                      color: "#ffffff",
                      textShadow: `rgba(${hexToRgb(
                        primaryColor
                      )}, 0.5) 0px 0px 10px`,
                    }}
                  >
                    {/* {renderContentTy()} */}
                    Thank You
                  </h1>
                </div>
                {/* Subtitle */}
                <div className="flex flex-col font-rubik font-normal justify-center leading-[0] relative shrink-0 text-white text-xl text-center tracking-[-0.0753px]">
                  <p className="adjustLetterSpacing block leading-[1.799rem]">
                    {/* Thanks for playing in the future of teamwork! Your empathy
                    makes every mission count. */}
                     {renderContentTy()}
                  </p>
                </div>

                {/* Feedback Section Header */}
                {formData.gameIsCollectLearnerFeedback === 'true' && (
                  <>
                    <div className="box-border content-stretch flex flex-row gap-1 items-center justify-start p-0 relative shrink-0 w-full lg:mb-6">
                      <div className="basis-0 flex grow items-center justify-center min-h-px min-w-px relative shrink-0">
                        <div className="h-0 relative w-full">
                          <div className="absolute bottom-0 left-0 right-0 top-[-2px]">
                            <svg
                              className="block h-full w-full"
                              fill="none"
                              preserveAspectRatio="none"
                              viewBox="0 0 456 2"
                            >
                              <line
                                stroke={`url(#paint0_linear_feedback_${primaryColor.replace(
                                  "#",
                                  ""
                                )})`}
                                strokeWidth="2"
                                x2="455.24"
                                y1="1"
                                y2="1"
                              />
                              <defs>
                                <linearGradient
                                  gradientUnits="userSpaceOnUse"
                                  id={`paint0_linear_feedback_${primaryColor.replace(
                                    "#",
                                    ""
                                  )}`}
                                  x1="455.24"
                                  x2="0"
                                  y1="1.9999"
                                  y2="1.99991"
                                >
                                  <stop stopColor={primaryColor} stopOpacity="0" />
                                  <stop
                                    offset="0.484375"
                                    stopColor={primaryColor}
                                    stopOpacity="0.994792"
                                  />
                                  <stop
                                    offset="1"
                                    stopColor={primaryColor}
                                    stopOpacity="0"
                                  />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        className="flex flex-col justify-center leading-[0] not-italic relative shrink-0 text-[#ffffff] text-xl text-center text-nowrap tracking-[0.08px]"
                        style={{
                          textShadow: `rgba(${hexToRgb(
                            primaryColor
                          )}, 0.5) 0px 0px 10px`,
                        }}
                      >
                        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
                          Feedback
                        </p>
                      </div>
                      <div className="basis-0 flex grow items-center justify-center min-h-px min-w-px relative shrink-0">
                        <div className="h-0 relative w-full">
                          <div className="absolute bottom-0 left-0 right-0 top-[-2px]">
                            <svg
                              className="block h-full w-full"
                              fill="none"
                              preserveAspectRatio="none"
                              viewBox="0 0 456 2"
                            >
                              <line
                                stroke={`url(#paint0_linear_feedback_${primaryColor.replace(
                                  "#",
                                  ""
                                )})`}
                                strokeWidth="2"
                                x2="455.24"
                                y1="1"
                                y2="1"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Question */}
                    <div className="box-border content-stretch flex flex-col gap-[1.799rem] items-center justify-start p-0 relative shrink-0 ">
                      <div className="flex flex-col font-rubik font-normal justify-center leading-[0] relative shrink-0 text-[#bdbdbd] text-[1.194rem] text-center tracking-[-0.0753px]">
                        <p className="adjustLetterSpacing block leading-[1.799rem]">
                          How do you feel about the experience ?
                        </p>
                      </div>
                    </div>
                  </>)}
              </div>
              {formData.gameIsCollectLearnerFeedback === 'true' && (
                <>
                  <div className="w-full relative z-10 flex-shrink-0 max-h-[500px] overflow-y-auto flex-1">
                    <div className="relative">
                      <div className="w-full max-w-full mx-auto">
                        <div className="relative">
                          {/* Feedback Categories */}
                          <div
                            className="grid gap-8 w-full"
                            style={{
                              gridTemplateColumns: (() => {
                                const visibleSections = [
                                  formData.gameContent === 'true',
                                  formData.gameRelevance === 'true',
                                  formData.gameBehaviour === 'true',
                                  formData.gameGamification === 'true',
                                  formData.gameRecommendation === 'true',
                                  formData.gameOthers === 'true',
                                ].filter(Boolean).length;

                                return visibleSections === 1 ? "1fr" : "repeat(2, 1fr)";
                              })(),
                            }}
                          >
                            {(() => {
                              // old UI logic (now inline)
                              const activeSections = [
                                formData.gameContent === "true" && "content",
                                formData.gameRelevance === "true" && "relevance",
                                formData.gameBehaviour === "true" && "behaviour",
                                formData.gameGamification === "true" && "gamification",
                                formData.gameRecommendation === "true" && "recommendation",
                                formData.gameOthers === "true" && "others",
                              ].filter(Boolean);

                              const totalActive = activeSections.length;
                              const thirdValue = activeSections[2];

                              const getSpanClass = (name: any) => {
                                if (name === "others") return "col-span-2";
                                if (totalActive === 1) return "col-span-2";
                                if (totalActive === 3 && thirdValue === name) return "col-span-2";
                                return "";
                              };

                              return (
                                <>
                                  {/* Content */}
                                  {formData.gameContent === "true" && (
                                    <div className={`flex flex-col gap-2 items-center justify-center w-full ${getSpanClass("content")}`}>
                                      <p className="font-rubik text-white text-base text-center tracking-[-0.08px]">
                                        Content
                                      </p>
                                      <div className="flex gap-3 w-full">
                                        <FeedbackCard
                                          icon={<FaceSmile />}
                                          text="I learned something useful"
                                          // isSelected={selectedFeedback.content === "useful"}
                                      isSelected={
  userInputs.gameContent === "I learned something useful"
}
                                            onClick={() =>
                                    handleOptionClick(
                                      'I learned something useful',
                                      'gameContent',
                                    )
                                  }
                                        />
                                        <FeedbackCard
                                          icon={<FaceMeh />}
                                          text="It wasn't useful"
                                          // isSelected={selectedFeedback.content === "not-useful"}
                                         isSelected={
  userInputs.gameContent === "It wasn't useful"
}
                                              onClick={() =>
                                    handleOptionClick(  
                                      "It wasn't useful",
                                      'gameContent',
                                    )
                                  }
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Relevance */}
                                  {formData.gameRelevance === "true" && (
                                    <div className={`flex flex-col gap-2 items-center justify-center w-full ${getSpanClass("relevance")}`}>
                                      <p className="font-rubik text-white text-base text-center tracking-[-0.08px]">
                                        Relevance
                                      </p>
                                      <div className="flex gap-3 w-full">
                                        <FeedbackCard
                                          icon={<FaceSmileWink />}
                                          text="I'll apply what I learned"
                                          // isSelected={selectedFeedback.relevance === "apply"}
                                         isSelected={
  userInputs.gameRelevance === "I'll apply what I learned"
}
                                           onClick={() =>
                                    handleOptionClick(
                                      "I'll apply what I learned",
                                      'gameRelevance',
                                    )
                                  }
                                        />
                                        <FeedbackCard
                                          icon={<FaceDiagonalMouth />}
                                          text="It's not relevant to me"
                                          // isSelected={selectedFeedback.relevance === "not-relevant"}
                                          isSelected={
  userInputs.gameRelevance === "It's not relevant to me"
}
                                           onClick={() =>
                                    handleOptionClick(
                                      "It's not relevant to me",
                                      'gameRelevance',
                                    )
                                  }
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Behaviour */}
                                  {formData.gameBehaviour === "true" && (
                                    <div className={`flex flex-col gap-2 items-center justify-center w-full ${getSpanClass("behaviour")}`}>
                                      <p className="font-rubik text-white text-base text-center tracking-[-0.08px]">
                                        Behaviour
                                      </p>
                                      <div className="flex gap-3 w-full">
                                        <FeedbackCard
                                          icon={<FaceGrinStars />}
                                          text="I understood what I can do differently"
                                          // isSelected={selectedFeedback.behaviour === "understood"}
                                         isSelected={
  userInputs.gameBehaviour === "I understood what I can do differently"
}
                                            onClick={() =>
                                    handleOptionClick(
                                      'I understood what I can do differently',
                                      'gameBehaviour',
                                    )
                                  }
                                        />
                                        <FeedbackCard
                                          icon={<FaceMehBlank />}
                                          text="I'm not sure"
                                          // isSelected={selectedFeedback.behaviour === "not-sure"}
                                        isSelected={
  userInputs.gameBehaviour === "I'm not sure"
}
                                          onClick={() =>
                                    handleOptionClick(
                                      `I'm not sure`,
                                      'gameBehaviour',
                                    )
                                  }
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Gamification */}
                                  {formData.gameGamification === "true" && (
                                    <div className={`flex flex-col gap-2 items-center justify-center w-full ${getSpanClass("gamification")}`}>
                                      <p className="font-rubik text-white text-base text-center tracking-[-0.08px]">
                                        Gamification
                                      </p>
                                      <div className="flex gap-3 w-full">
                                        <FeedbackCard
                                          icon={<Like />}
                                          text="I would like to learn via games"
                                          isSelected={
  userInputs.gameGamification === "I liked learning through this graphical theme"
}
                                          // isSelected={selectedFeedback.gamification === "like-games"}
                                          onClick={() =>
                                    handleOptionClick(
                                      'I liked learning through this graphical theme',
                                      'gameGamification',
                                    )
                                  }
                                        />
                                        <FeedbackCard
                                          icon={<Dislike />}
                                          text="I don't like this format"
                                          isSelected={
  userInputs.gameGamification === "I didn’t like this theme"
}
                                          // isSelected={selectedFeedback.gamification === "dislike-format"}
                                          onClick={() =>
                                    handleOptionClick(
                                      "I didn’t like this theme",
                                      'gameGamification',
                                    )
                                  }
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Recommendation */}
                                  {formData.gameRecommendation === "true" && (
                                    <div className={`flex flex-col gap-2 items-center justify-center w-full ${getSpanClass("recommendation")}`}>
                                      <p className="font-rubik text-white text-base text-center tracking-[-0.08px]">
                                        Recommendation
                                      </p>
                                      <div className="flex gap-3 w-full">
                                        <FeedbackCard
                                          icon={<FaceSmile />}
                                          text="I would recommend this game to others"
                                          isSelected={
  userInputs.gameRecommendation === "I would recommend this game to others"
}
                                          // isSelected={selectedFeedback.recommendation === "recommend"}
                                           onClick={() =>
                                    handleOptionClick(
                                      'I would recommend this game to others',
                                      'gameRecommendation',
                                    )
                                  }
                                        />
                                        <FeedbackCard
                                          icon={<FaceMeh />}
                                          text="I wouldn't recommend"
                                          isSelected={
  userInputs.gameRecommendation === "I wouldn't recommend"
}
                                          // isSelected={selectedFeedback.recommendation === "not-recommend"}
                                            onClick={() =>
                                    handleOptionClick(
                                      "I wouldn't recommend",
                                      'gameRecommendation',
                                    )
                                  }
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Others */}
                                  {formData.gameOthers === "true" && (
                                    <div className={`flex flex-col gap-2 items-center justify-center w-full ${getSpanClass("others")}`}>
                                      <p className="font-rubik text-white text-base text-center tracking-[-0.08px]">
                                        Anything else you'd like to share
                                      </p>
                                      <textarea
                                        className="w-full min-h-[90px] p-3 rounded-lg bg-[#1a1a1a] text-white border border-[#b3a484]"
                                        placeholder="Leave your comments here..."
                                        onChange={(e) => handleOtherFeedbackChange(e.target.value, "gameOthers")}
                                      />
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </>)}
              <div className="flex flex-col gap-5  w-full">
                {/* Feedback Link Section */}
                {formData.gameIsCollectLearnerFeedback === 'true' && (
                  <>
                    <div className="box-border content-stretch flex flex-col gap-6 items-center justify-start relative shrink-0 w-full">
                      {/* Link Header */}
                      {formData.gameFeedBack === 'true' && formData.gameFeedBackLink && (
                        <>
                          <div className="box-border content-stretch flex flex-row gap-1 items-center justify-start p-0 relative shrink-0 w-full">
                            <div className="basis-0 flex grow items-center justify-center min-h-px min-w-px relative shrink-0">
                              <div className="h-0 relative w-full">
                                <div className="absolute bottom-0 left-0 right-0 top-[-2px]">
                                  <svg
                                    className="block h-full w-full"
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 179 2"
                                  >
                                    <line
                                      stroke={`url(#paint0_linear_link_${primaryColor.replace(
                                        "#",
                                        ""
                                      )})`}
                                      strokeWidth="2"
                                      x2="178.74"
                                      y1="1"
                                      y2="1"
                                    />
                                    <defs>
                                      <linearGradient
                                        gradientUnits="userSpaceOnUse"
                                        id={`paint0_linear_link_${primaryColor.replace(
                                          "#",
                                          ""
                                        )}`}
                                        x1="178.74"
                                        x2="0"
                                        y1="1.9999"
                                        y2="1.9999"
                                      >
                                        <stop stopColor={primaryColor} stopOpacity="0" />
                                        <stop
                                          offset="0.484375"
                                          stopColor={primaryColor}
                                          stopOpacity="0.994792"
                                        />
                                        <stop
                                          offset="1"
                                          stopColor={primaryColor}
                                          stopOpacity="0"
                                        />
                                      </linearGradient>
                                    </defs>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col font-rubik justify-center leading-[0] not-italic relative shrink-0 text-white text-xl text-center">
                              <p className="adjustLetterSpacing block leading-[2.946rem]">
                                Could you please share your feedbacks with us on the below
                                link :
                              </p>
                            </div>
                            <div className="basis-0 flex grow items-center justify-center min-h-px min-w-px relative shrink-0">
                              <div className="h-0 relative w-full">
                                <div className="absolute bottom-0 left-0 right-0 top-[-2px]">
                                  <svg
                                    className="block h-full w-full"
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox="0 0 179 2"
                                  >
                                    <line
                                      stroke={`url(#paint0_linear_link_${primaryColor.replace(
                                        "#",
                                        ""
                                      )})`}
                                      strokeWidth="2"
                                      x2="178.74"
                                      y1="1"
                                      y2="1"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>)}
                    </div>
                  </>)}

                {/* Bottom Navigation */}
                <div className="flex justify-between items-center w-full">
                  <NavigationArrow
                    direction="left"
                       onClick={() => {
      playMenuSound();      
    previousNavigation();    
  }}
                  />
                  {formData.gameIsCollectLearnerFeedback === 'true' && (<>
                    {formData.gameFeedBack === 'true' && formData.gameFeedBackLink && (<>
                      <div className="flex flex-col  justify-center leading-[0] not-italic relative shrink-0 text-xl text-center text-nowrap text-white">
                        <a
                          className="[text-decoration-line:underline] [text-decoration-skip-ink:none] [text-decoration-style:solid] [text-underline-position:from-font] block leading-[2.946rem] whitespace-pre"
                          href={formData.gameFeedBackLink}
                          target="_blank"
                        >
                          {formData.gameFeedBackLink}
                        </a>
                      </div>
                    </>)}
                  </>)}
                  {/* <NavigationArrow
                    direction="right"
                     onClick={() => {
         playMenuSound();         
    handleNext();    
  }}
                  /> */}
                  <NavigationArrow
  direction="right"
  onClick={() => {
    playMenuSound();
    // setShowTestimonialPopup(true);
      checkTestimonialAndProceed();
  }}
/>
                </div>
              </div>
            
              {/* Inset Shadow Border */}
              <div
                className="absolute inset-0 pointer-events-none rounded-[2.375rem]"
                style={{
                  boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                    primaryColor
                  )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                    primaryColor
                  )}, 0.2)`,
                }}
              />
            </div>
          </div>
        </div>

        {showTestimonialPopup && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm">
    <div
      className="w-full max-w-[500px] rounded-2xl p-6 border"
      style={{
        background: `linear-gradient(
          135deg,
          rgba(${hexToRgb(primaryColor)},0.18),
          rgba(0,0,0,0.9)
        )`,
        borderColor: primaryColor,
      }}
    >
      {/* Title */}
      <h2
        className="text-2xl font-semibold text-center mb-3"
        style={{
          color: "#fff",
          textShadow: `0 0 10px rgba(${hexToRgb(primaryColor)},0.6)`,
        }}
      >
        Share Your Experience
      </h2>

      {/* Subtitle */}
      <p className="text-center text-gray-300 mb-5">
        {/* How was your game experience? */}
        Your story can help ECHO reach more learners and support their leadership growth.
      </p>

      {/* Textarea */}
      <Textarea
        value={testimonialText}
        onChange={(e) => setTestimonialText(e.target.value)}
        // placeholder="Write your testimonial here..."
        placeholder="Share what stood out to you and how ECHO made a difference in your day-to-day leadership moments."
        className="min-h-[140px] bg-black/40 text-white border-[#ffffff33]"
      />

      {/* Buttons */}
      <div className="flex justify-end gap-3 mt-5">
        <button
          onClick={() => setShowTestimonialPopup(false)}
          className="px-5 py-2 rounded-lg border border-white/30 text-white hover:bg-white/10 transition"
        >
          Close
        </button>

        <button
          onClick={handleTestimonialSubmit}
          className="px-5 py-2 rounded-lg text-black font-semibold transition"
          style={{
            background: primaryColor,
          }}
        >
          Submit
        </button>
      </div>
    </div>
  </div>
)}
      </div>

      
    );
  };



export default ThankyouFutureTheme;
